import { render, staticRenderFns } from "./SkeletonListWrap.vue?vue&type=template&id=d707c390&"
import script from "./SkeletonListWrap.vue?vue&type=script&lang=js&"
export * from "./SkeletonListWrap.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonListWrap.vue?vue&type=style&index=0&id=d707c390&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports